<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div class="relative w-full max-w-lg bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 p-6 md:p-8 animate-fade-in-up max-h-[90vh] overflow-y-auto custom-scrollbar">

    <div *ngIf="isSaving()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex items-center justify-between mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">folder</span>
        {{ isEdit ? 'แก้ไขกลุ่ม Fee' : 'เพิ่มกลุ่ม Fee' }}
      </h3>
      <button type="button" (click)="onClose()"
        class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="space-y-5">
      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อ <span class="text-rose-500">*</span></label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-[20px]">folder</span>
          <input type="text" placeholder="ชื่อกลุ่ม Fee" [(ngModel)]="formData.name"
            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400">
        </div>
      </div>
    </div>

    <div class="flex justify-between gap-3 mt-8 pt-6 border-t border-slate-100 dark:border-slate-800">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex justify-end gap-3 ml-auto">
        <button type="button" (click)="onClose()" [disabled]="isSaving()"
          class="px-6 py-2.5 rounded-xl font-bold text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all disabled:opacity-50">
          ยกเลิก
        </button>
        <button type="button" (click)="onSave()" [disabled]="isSaving()"
          class="px-6 py-2.5 rounded-xl font-bold bg-amber-400 hover:bg-amber-500 text-white shadow-lg shadow-amber-200/50 dark:shadow-amber-900/20 transition-all disabled:opacity-60 flex items-center gap-2">
          <span *ngIf="isSaving()" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && editRow?.id"
  [entityType]="activityEntityTypes.ParkingFeeGroup"
  [entityId]="editRow!.id"
  title="ประวัติกลุ่มค่าธรรมเนียม"
  [subtitle]="'#' + editRow!.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
